const isUserSelectingText = () => {
  const selection = window.getSelection()
  if (selection && selection.toString()) {
    return true
  }
  return false
}
export { isUserSelectingText }
